import type { App } from 'vue'

import * as components from './components'

export * from './components'

export type * from './types'

export const install = function (app: App) {
  Object.keys(components).forEach((key) => {
    const component = components[key]
    if (component.install) {
      app.use(component)
    }
  })
  return app
}

export * from './Modal'
export * from './Form'
export * from './Tree'
export * from './Message'
export * from './MessageBox'
export * from './Pagetable'
export * from './Input'
export * from './Edittable'
export * from './Tabs'
